import { errorHandler, logger } from '@/tools';
import { errorTypes } from '@/types';
import store from '@/store';

export async function validateArticle(to, from, next) {
	logger.log('validateArticle');
	const { exhibitionID, articleID } = to.params;
	if (typeof articleID === 'undefined') return next();
	logger.log(`#router validate: article on route: ${to.name}`);
	if (!store.state.dataSourceCFG.exhibitionMap[exhibitionID].articleMap[articleID]) {
		errorHandler(new Error(errorTypes.unkownArticle));
		return next(false);
	}
	next();
}

export async function validateStayInTour(to, from, next) {
	logger.log('#router validate: validateStayInTour');
	const fromTourID = from.params.tourID;
	const { tourID, exhibitionID, articleID } = to.params;
	const { endTour } = to.query;
	logger.log(
		`validateStayInTour from: ${fromTourID}, to: ${tourID}, ex: ${exhibitionID}, art: ${articleID}, endTour:${endTour}`
	);
	if (fromTourID && !tourID && !endTour) {
		const fromTour = store.state.tour.toursMap[fromTourID];
		if (!fromTour) {
			errorHandler(new Error(errorTypes.unknownTour));
			return next(false);
		}
		if (fromTour.endTourOnlyOnCommand) {
			logger.log('stay in tour, redirect to url with /tour/[id]');
			next({
				path: `/${exhibitionID}/tour/${fromTourID}/${articleID}`,
				query: to.query,
				replace: true,
			});
			return;
		}
	}
	next();
}

export async function validateArticleInTour(to, from, next) {
	const { tourID, articleID } = to.params;
	if (typeof tourID === 'undefined' || typeof articleID === 'undefined') return next();
	const tour = store.state.tour.toursMap[tourID];
	logger.log(`#router validate: article in tour on route: ${to.name}`);
	// if the explicit end tour flag is set do not leave the tour even if the article does not belong
	if (tour.endTourOnlyOnCommand) {
		return next();
	}
	// check if the article is part of the tour
	else if (!tour.exhibitIDs.some(element => element.articleID === articleID)) {
		errorHandler(new Error(errorTypes.articleNotInTour));

		return next(false);
	}
	return next();
}

export async function validateExhibition(to, from, next) {
	const { exhibitionID } = to.params;
	if (typeof exhibitionID === 'undefined') return next();
	logger.log(`#router validate: exhibition on route: ${to.path}`);
	if (!store.state.dataSourceCFG.exhibitionMap[exhibitionID]) {
		errorHandler(new Error(errorTypes.unkownExhibition));
		if (from.name == null) {
			// this is the case on startup
			return next(`/${store.state.dataSourceCFG.landingExhibition.exhibitionID}`);
		} else {
			return next(false);
		}
	}
	next();
}

export async function validateTour(to, from, next) {
	const { exhibitionID, tourID } = to.params;
	if (typeof tourID === 'undefined') return next();
	const tour = store.state.tour.toursMap[tourID];
	logger.log(`#router validate: tour on route: ${to.name}`);
	if (!tour || (!tour.endTourOnlyOnCommand && tour.exhibitionID !== exhibitionID)) {
		errorHandler(new Error(errorTypes.unknownTour));
		return next(false);
	}
	next();
}
